module.exports = __webpack_public_path__ + "img/192.087cef47.png";